module.exports = __webpack_public_path__ + "static/media/icon_tick.7c148283.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_tick.svg
// module id = 382
// module chunks = 0